import React, { Fragment } from "react";
import { Button, Form } from "react-bootstrap";

export const AccountFormRoler = ({
  isAdmin,
  roler,
  authForm,
  handleRoler,
  handleDSUnivId,
  handleDSUnivPassword,
  handleDSUnivSubmit,
}) => {
  return (
    <Fragment>
      <Form.Group controlId="roler">
        <Form.Label>역할</Form.Label>
        <Form.Select
          id="roler"
          defaultValue={roler ?? "amdin"}
          onChange={handleRoler}
          disabled={!isAdmin}
        >
          <option value="amdin">amdin</option>
          <option value="manager">manager</option>
          <option value="professor">professor</option>
          <option value="student">student</option>
          <option value="tester">tester</option>
        </Form.Select>
      </Form.Group>

      {
        authForm.show ? (
          <section className="dsuni-link-box">
            <div>학사 시스템 인증</div>
            <hr />
            <Form.Group controlId="dsuni-link-id">
              <Form.Label>{authForm.name}</Form.Label>
              <Form.Control
                onChange={handleDSUnivId}
                type="text"
                placeholder="id"
              />
            </Form.Group>
            <Form.Group controlId="dsuni-link-password">
              <Form.Label>비밀 번호</Form.Label>
              <Form.Control
                onChange={handleDSUnivPassword}
                type="passwrod"
                placeholder="password"
              />
            </Form.Group>

            <br />
            <Form.Group controlId="dsuni-link-checked">
              <Form.Check type={"checkbox"}>
                <Form.Check.Input
                  disabled
                  readOnly
                  checked={authForm.authed}
                ></Form.Check.Input>
                <Form.Check.Label>인증 완료</Form.Check.Label>
              </Form.Check>
            </Form.Group>
            <Button className="dsuni-link-btn" onClick={handleDSUnivSubmit}>
              인증
            </Button>
          </section>
        ) : undefined //
      }
    </Fragment>
  );
};
